import { useState } from 'react';
import { useWishlistQuery } from '../../api/useWishlistQueries';
import type { WishlistListFilter } from '../../api/wishlistApi';

const PAGE_SIZE = 10;

/** Owns wishlist pagination state and derived list/range values. */
export function useWishlistPage() {
  const [filter, setFilter] = useState<WishlistListFilter>({
    page: 1,
    limit: PAGE_SIZE,
  });

  const listQuery = useWishlistQuery(filter);
  const billboards = listQuery.data?.data?.billboards || [];
  const pagination = listQuery.data?.data?.pagination;
  const totalItems = Number(pagination?.total || 0);
  const totalPages = Math.max(1, Number(pagination?.pages || 1));

  const from = totalItems === 0 ? 0 : (filter.page - 1) * filter.limit + 1;
  const to = Math.min(filter.page * filter.limit, totalItems);
  const rangeLabel =
    totalItems === 0
      ? 'No saved screens'
      : `${from}–${to} of ${totalItems} screens`;

  const setPage = (updater: (page: number) => number) => {
    setFilter((prev) => {
      const nextPage = updater(prev.page);
      return {
        ...prev,
        page: Math.min(Math.max(1, nextPage), totalPages),
      };
    });
  };

  return {
    filter,
    setPage,
    billboards,
    totalPages,
    totalItems,
    rangeLabel,
    isPending: listQuery.isPending,
    isError: listQuery.isError,
  };
}
